import { render, staticRenderFns } from "./settings-helper-components-2-header.vue?vue&type=template&id=98535fa2&scoped=true&"
import script from "./settings-helper-components-2-header.vue?vue&type=script&lang=ts&"
export * from "./settings-helper-components-2-header.vue?vue&type=script&lang=ts&"
import style0 from "./settings-helper-components-2-header.vue?vue&type=style&index=0&id=98535fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98535fa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
